import { Box } from '@mui/material'
import PrimaryButton from '../common/PrimaryButton'

export default function StoriesLoadMoreButton({ onClick }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <PrimaryButton
        onClick={onClick}
        showArrow={false}
      >
        Load More Stories
      </PrimaryButton>
    </Box>
  )
}
